import { hotTopics } from "@/mocks/suye";
import { catName } from "./SectionHeading";

export default function HotRank() {
  return (
    <section id="hot" className="border-b border-background-200 bg-background-100/60 py-14 md:py-20">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-3">
          <div className="lg:col-span-2">
            <div className="mb-6 flex flex-wrap items-end justify-between gap-3">
              <div>
                <span className="inline-flex items-center gap-2 text-xs font-bold tracking-[0.22em] text-primary-600 uppercase">
                  <span className="h-px w-6 bg-primary-500" />
                  实时热榜
                </span>
                <h2 className="mt-3 flex items-center gap-3 font-heading text-2xl font-black tracking-tight text-foreground-950 md:text-4xl">
                  <i className="ri-fire-fill text-accent-500" />
                  此刻最热
                </h2>
              </div>
              <span className="inline-flex items-center gap-1.5 rounded-full bg-secondary-100 px-3 py-1 text-xs font-medium text-secondary-800">
                <span className="pulse-dot h-1.5 w-1.5 rounded-full bg-primary-500" />
                每 2 分钟刷新一次
              </span>
            </div>

            <ol className="divide-y divide-background-200 overflow-hidden rounded-2xl border border-background-200 bg-background-50">
              {hotTopics.map((t, idx) => (
                <li key={t.id}>
                  <a href="#live" className="group flex items-center gap-4 px-4 py-4 transition-colors hover:bg-background-100 md:gap-6 md:px-6">
                    <span
                      className={
                        "w-9 shrink-0 text-center font-heading text-2xl font-black " +
                        (idx < 3 ? "text-primary-600" : "text-foreground-300")
                      }
                    >
                      {String(idx + 1).padStart(2, "0")}
                    </span>
                    <span className="flex-1">
                      <span className="flex flex-wrap items-center gap-2">
                        <span
                          className={
                            "rounded px-1.5 py-0.5 text-[10px] font-bold " +
                            (t.tag === "爆"
                              ? "bg-primary-500 text-background-50"
                              : t.tag === "新"
                                ? "bg-accent-100 text-accent-800"
                                : "bg-background-200 text-foreground-600")
                          }
                        >
                          {t.tag}
                        </span>
                        <span className="whitespace-nowrap rounded-full bg-secondary-100 px-2 py-0.5 text-[10px] font-medium text-secondary-800">
                          {catName(t.categoryId)}
                        </span>
                      </span>
                      <span className="mt-2 block font-medium leading-snug text-foreground-950 transition-colors group-hover:text-primary-700">
                        {t.title}
                      </span>
                      <span className="mt-2 flex items-center gap-4 text-xs text-foreground-500">
                        <span className="inline-flex items-center gap-1">
                          <i className="ri-eye-line" /> {t.views} 围观
                        </span>
                        <span className="inline-flex items-center gap-1">
                          <i className={t.up ? "ri-arrow-up-line text-accent-600" : "ri-arrow-down-line text-foreground-400"} />
                          热度 {t.heat}
                        </span>
                      </span>
                    </span>
                    <span className="hidden w-28 shrink-0 sm:block">
                      <span className="mb-1.5 block text-right text-[10px] text-foreground-400">热度 {t.heat}%</span>
                      <span className="block h-1.5 overflow-hidden rounded-full bg-background-200">
                        <span
                          className={"block h-full rounded-full " + (idx < 3 ? "bg-primary-500" : "bg-accent-500")}
                          style={{ width: t.heat + "%" }}
                        />
                      </span>
                    </span>
                    <i className="ri-arrow-right-up-line text-foreground-300 transition-colors group-hover:text-primary-500" />
                  </a>
                </li>
              ))}
            </ol>
          </div>

          <aside className="flex flex-col gap-6">
            <div className="overflow-hidden rounded-2xl border border-background-200 bg-foreground-950">
              <div className="flex items-center justify-between px-5 pt-5">
                <span className="flex items-center gap-2 text-sm font-bold text-background-50">
                  <span className="pulse-dot h-2 w-2 rounded-full bg-primary-500" />
                  今日爆点
                </span>
                <span className="rounded-full bg-background-50/10 px-2.5 py-0.5 text-[10px] font-medium text-background-200">持续围观中</span>
              </div>
              <div className="p-5 pt-3">
                <p className="font-heading text-xl font-black leading-snug text-background-50">
                  当红男团巡演连开三城，票务系统全程“挤爆”
                </p>
                <p className="mt-3 text-sm leading-relaxed text-background-200/90">
                  从放票到转卖，实名、黄牛与加场互相拉扯。我们持续跟进两边的回应与最新票务规则，进展将随时更新在这条时间线下。
                </p>
                <a
                  href="#live"
                  className="mt-5 inline-flex items-center gap-2 rounded-full bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
                >
                  围观进展 <i className="ri-arrow-right-line" />
                </a>
              </div>
            </div>

            <div className="rounded-2xl border border-background-200 bg-background-50 p-5">
              <h3 className="flex items-center gap-2 text-sm font-bold text-foreground-950">
                <i className="ri-team-line text-primary-500" />
                今天谁在前排
              </h3>
              <div className="mt-4 space-y-3">
                {[
                  { n: "文娱圈", v: "1.2w", p: "72" },
                  { n: "网络梗", v: "1.5w", p: "64" },
                  { n: "科技风", v: "8.6k", p: "51" },
                ].map((s) => (
                  <div key={s.n}>
                    <div className="mb-1 flex items-center justify-between text-xs">
                      <span className="text-foreground-700">{s.n}</span>
                      <span className="text-foreground-500">{s.v} 在线</span>
                    </div>
                    <span className="block h-1.5 overflow-hidden rounded-full bg-background-200">
                      <span className="block h-full rounded-full bg-accent-500" style={{ width: s.p + "%" }} />
                    </span>
                  </div>
                ))}
              </div>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}